// Create animated background particles
function createParticles() {
    const particlesContainer = document.getElementById('particles');
    const particleCount = 50;

    for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        particle.style.left = Math.random() * 100 + '%';
        particle.style.animationDelay = Math.random() * 6 + 's';
        particle.style.animationDuration = (Math.random() * 3 + 3) + 's';
        particlesContainer.appendChild(particle);
    }
}

// Theme toggle functionality
const themeToggle = document.getElementById('theme-toggle');
const body = document.body;
const themeIcon = themeToggle.querySelector('i');

function toggleTheme() {
    const currentTheme = body.getAttribute('data-theme');
    const newTheme = currentTheme === 'light' ? 'dark' : 'light';

    body.setAttribute('data-theme', newTheme);
    themeIcon.className = newTheme === 'light' ? 'fas fa-moon' : 'fas fa-sun';

    // Store theme preference
    localStorage.setItem('theme', newTheme);
}

// Load saved theme
const savedTheme = localStorage.getItem('theme') || 'dark';
body.setAttribute('data-theme', savedTheme);
themeIcon.className = savedTheme === 'light' ? 'fas fa-moon' : 'fas fa-sun';

themeToggle.addEventListener('click', toggleTheme);

// Typing animation
function typeWriter(element, text, speed = 100) {
    let i = 0;
    element.innerHTML = '';

    function type() {
        if (i < text.length) {
            element.innerHTML += text.charAt(i);
            i++;
            setTimeout(type, speed);
        } else {
            setTimeout(() => {
                element.innerHTML = '';
                i = 0;
                type();
            }, 2000);
        }
    }
    type();
}

// Terminal-style typing animation
function terminalTypeWriter(element, command, output, speed = 100) {
    let i = 0;
    let playCount = 0;
    const maxPlays = 1;

    function type() {
        if (playCount >= maxPlays) {
            // Stay on final state after 1 play
            element.innerHTML = command + '<br>' +
                output.replace(/\n/g, '<br>');
            // Show the second prompt after animation completes
            const secondPrompt = document.getElementById('second-prompt');
            if (secondPrompt) {
                secondPrompt.style.display = 'flex';
            }
            return;
        }

        if (i < command.length) {
            element.innerHTML = command.substring(0, i + 1) + '<span class="typing-cursor"></span>';
            i++;
            setTimeout(type, speed);
        } else {
            // Instantly show the output after the command
            element.innerHTML = command + '<br>' +
                output.replace(/\n/g, '<br>');
            playCount++;
            // Show the second prompt after animation completes
            const secondPrompt = document.getElementById('second-prompt');
            if (secondPrompt) {
                secondPrompt.style.display = 'flex';
            }
            // Don't reset - stay on final state
        }
    }
    type();
}

// Code block typewriter animation
function codeTypeWriter() {
    const codeContent = document.getElementById('code-content');
    const codeLines = [
        'class Developer:',
        '    def __init__(self):',
        '        self.name = \'Chase\'',
        '        self.role = \'Software Engineer\'',
        '        self.passion = \'Building awesome software!\'',
        '',
        '    def create_future(self):',
        '        return \'Ready to innovate!\'',
        '',
        '# Ready to create the future',
        'chase = Developer()'
    ];

    let currentLine = 0;
    let currentChar = 0;
    let playCount = 0;
    const maxPlays = 1;

    function typeCode() {
        if (playCount >= maxPlays) {
            // Stay on final state after 1 play
            return;
        }
        if (currentLine < codeLines.length) {
            const line = codeLines[currentLine];

            if (currentChar === 0) {
                // Create new line element
                const lineElement = document.createElement('div');
                lineElement.className = 'code-line';
                codeContent.appendChild(lineElement);
            }

            const currentLineElement = codeContent.children[currentLine];

            if (currentChar < line.length) {
                // Type character by character with syntax highlighting
                const char = line[currentChar];
                let displayChar = char;

                // Apply syntax highlighting based on context
                if (line.startsWith('class ') && currentChar < 5) {
                    displayChar = `<span class="keyword">${char}</span>`;
                } else if (line.includes('def ') && currentChar >= line.indexOf('def ') && currentChar < line.indexOf('def ') + 3) {
                    displayChar = `<span class="keyword">${char}</span>`;
                } else if (line.includes('__init__') && currentChar >= line.indexOf('__init__') && currentChar < line.indexOf('__init__') + 8) {
                    displayChar = `<span class="function">${char}</span>`;
                } else if (line.includes('create_future') && currentChar >= line.indexOf('create_future') && currentChar < line.indexOf('create_future') + 13) {
                    displayChar = `<span class="function">${char}</span>`;
                } else if (line.includes('self') && currentChar >= line.indexOf('self') && currentChar < line.indexOf('self') + 4) {
                    displayChar = `<span class="method">${char}</span>`;
                } else if (line.includes('Developer') && currentChar >= line.indexOf('Developer') && currentChar < line.indexOf('Developer') + 9) {
                    displayChar = `<span class="class-name">${char}</span>`;
                } else if (line.includes('\'') && currentChar >= line.indexOf('\'') && currentChar < line.lastIndexOf('\'') + 1) {
                    displayChar = `<span class="string">${char}</span>`;
                } else if (line.startsWith('#') && currentChar === 0) {
                    displayChar = `<span class="comment">${char}</span>`;
                } else if (line.startsWith('#') && currentChar > 0) {
                    displayChar = `<span class="comment">${char}</span>`;
                } else if (line.includes('return') && currentChar >= line.indexOf('return') && currentChar < line.indexOf('return') + 6) {
                    displayChar = `<span class="keyword">${char}</span>`;
                }

                currentLineElement.innerHTML += displayChar;
                currentChar++;
                setTimeout(typeCode, 15); // Faster character-by-character typing
            } else {
                // Move to next line
                currentLine++;
                currentChar = 0;
                setTimeout(typeCode, 25); // Faster pause between lines
            }
        } else {
            // Stay on final state - don't reset
            playCount++;
        }
    }

    typeCode();
}

// Auto-scroll terminal content to bottom
function scrollTerminalToBottom() {
    const terminalContent = document.getElementById('terminal-content');
    if (terminalContent) {
        terminalContent.scrollTop = terminalContent.scrollHeight;
    }
}

// Navbar scroll effect
window.addEventListener('scroll', () => {
    const navbar = document.getElementById('navbar');
    if (window.scrollY > 50) {
        navbar.classList.add('scrolled');
    } else {
        navbar.classList.remove('scrolled');
    }
});

// Smooth scrolling for navigation links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// Intersection Observer for fade-in animations
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
        }
    });
}, observerOptions);

document.querySelectorAll('.fade-in').forEach(el => {
    observer.observe(el);
});

// Timeline animations
const timelineItems = document.querySelectorAll('.timeline-item');
const timelineObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
            setTimeout(() => {
                entry.target.style.animationDelay = `${index * 0.2}s`;
                entry.target.style.animation = 'fadeInUp 0.6s ease forwards';
            }, index * 100);
        }
    });
}, { threshold: 0.3 });

timelineItems.forEach(item => {
    timelineObserver.observe(item);
});



// Contact form handling
document.getElementById('contact-form').addEventListener('submit', function (e) {
    e.preventDefault();

    const name = document.getElementById('name').value.trim();
    const email = document.getElementById('email').value.trim();
    const subject = document.getElementById('subject').value.trim();
    const message = document.getElementById('message').value.trim();

    // Construct the mailto link
    const mailto = `mailto:chasebwilcox@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
        `Name: ${name}\nEmail: ${email}\n\n${message}`
    )}`;

    // Open the user's email client
    window.location.href = mailto;
});

// Improved parallax effect for hero section
let ticking = false;
function updateParallax() {
    const scrolled = window.pageYOffset;
    const hero = document.querySelector('.hero');
    const heroContent = document.querySelector('.hero-container');

    if (hero && heroContent) {
        // Only apply parallax when hero is in view
        const heroRect = hero.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (heroRect.bottom > 0 && heroRect.top < windowHeight) {
            // Further reduced parallax effect to give more space for terminal
            const parallaxOffset = scrolled * 0.08;
            heroContent.style.transform = `translateY(${parallaxOffset}px)`;
        }
    }

    ticking = false;
}

function requestTick() {
    if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
    }
}

window.addEventListener('scroll', requestTick);

// Copy to clipboard functionality
function copyToClipboard(text, message) {
    navigator.clipboard.writeText(text).then(() => {
        // Create and show notification
        const notification = document.createElement('div');
        notification.style.cssText = `
                    position: fixed;
                    top: 20px;
                    left: 50%;
                    transform: translateX(-50%) translateY(-100px);
                    background: var(--surface);
                    color: var(--text-primary);
                    padding: 0.75rem 1.5rem;
                    border-radius: 2rem;
                    box-shadow: var(--shadow-lg);
                    z-index: 10000;
                    font-weight: 500;
                    font-size: 0.9rem;
                    border: 1px solid var(--border);
                    transition: transform 0.3s ease;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                `;
        notification.innerHTML = `<i class="fas fa-check" style="color: var(--primary);"></i>${message}`;
        document.body.appendChild(notification);

        // Animate in
        setTimeout(() => {
            notification.style.transform = 'translateX(-50%) translateY(0)';
        }, 100);

        // Remove after 3 seconds
        setTimeout(() => {
            notification.style.transform = 'translateX(-50%) translateY(-100px)';
            setTimeout(() => {
                if (document.body.contains(notification)) {
                    document.body.removeChild(notification);
                }
            }, 300);
        }, 3000);
    }).catch(err => {
        console.error('Failed to copy: ', err);
    });
}

// Copy email functionality
function copyEmail() {
    copyToClipboard('chasebwilcox@gmail.com', 'Email copied to clipboard!');
}

// Copy phone functionality
function copyPhone() {
    copyToClipboard('012-345-6789', 'Phone number copied to clipboard!');
}

// Copy location functionality
function copyLocation() {
    copyToClipboard('Salt Lake City, Utah', 'Location copied to clipboard!');
}

// Initialize everything when DOM is loaded
document.addEventListener('DOMContentLoaded', function () {
    createParticles();
    terminalTypeWriter(
        document.getElementById('typing-content'),
        'fortune | cowsay -f tux',
        `  __________________________
/ Talking about music is like \\
\\ dancing about architecture. /
  ---------------------------
  \\
   \\
    .--.
   |o_o |
   |:_/ |
  //   \\ \\
 (|     | )
/'\\_   _/\\'
\\___)=(___/
`
    );
    codeTypeWriter(); // Start the code typewriter animation

    // Auto-scroll terminal periodically
    setInterval(scrollTerminalToBottom, 100);

    // Add click handlers for copy functionality
    const emailCopy = document.getElementById('email-copy');
    const phoneCopy = document.getElementById('phone-copy');
    const locationCopy = document.getElementById('location-copy');

    if (emailCopy) {
        emailCopy.addEventListener('click', copyEmail);
    }
    if (phoneCopy) {
        phoneCopy.addEventListener('click', copyPhone);
    }
    if (locationCopy) {
        locationCopy.addEventListener('click', copyLocation);
    }

    // Highlight form section on hover/focus of any field or the form box itself
    const formSection = document.querySelector('.contact-form');
    const fields = formSection.querySelectorAll('.form-input, .form-textarea');
    let activeCount = 0;

    function activateForm() {
        if (activeCount === 0) formSection.classList.add('form-active');
        activeCount++;
    }
    function deactivateForm() {
        activeCount--;
        if (activeCount <= 0) {
            formSection.classList.remove('form-active');
            activeCount = 0;
        }
    }
    // Field focus/blur for accessibility
    fields.forEach(field => {
        field.addEventListener('focus', activateForm);
        field.addEventListener('blur', deactivateForm);
    });
    // Form box hover
    formSection.addEventListener('mouseenter', activateForm);
    formSection.addEventListener('mouseleave', deactivateForm);
});
